import { batchedSubscribe } from 'redux-batched-subscribe';
import state from './state';

const enhancer = batchedSubscribe((freshNotify) => {
  state.notify = freshNotify;
});

export default enhancer;
